import {ToWords} from "to-words";

export default function figureFormatter () {
    const commaFormat = (value, fractionDigits = 2) => {
        if(! value) {
            return 0.00
        }

        return new Intl.NumberFormat('en-IN', {
            style: 'currency',
            currency: 'BDT',
            minimumFractionDigits: fractionDigits,
            maximumFractionDigits: fractionDigits
        }).format(value).replace('BDT', '').trim()
    }

    const decimalFormat = (str) => {
        let firstOccuranceIndex = str.search(/\./) + 1; // Index of first occurance of (.)
        let decimalValue = str.substr(0, firstOccuranceIndex) + str.slice(firstOccuranceIndex).replace(/\./g, '');
        return decimalValue.toString().replace(/^[0]/g, '');
    }

    const currencyToWord = (value) => {
        const toWords = new ToWords({
            localeCode: 'en-BD',
            converterOptions: {
                currency: true,
                ignoreDecimal: false,
                ignoreZeroCurrency: false,
                doNotAddOnly: false,
            }
        });
        return toWords.convert(value);
    }

    const onlyCommaFormat = (value) => {
        return value.toLocaleString();
    }

    const capitalize = (text) => {
        if (!text || typeof text !== 'string') {
            return '';
        }

        return text.charAt(0).toUpperCase() + text.slice(1);
    }

    const limitText = (text, charLimit = 20) => {
        if (!text) return '';
        return text.length > charLimit
            ? text.substring(0, charLimit) + '..'
            : text;
    }

    const formatNameWithSerial = (name, serialNo) => {
        if (! serialNo) return name;
        return `${name} (${serialNo})`;
    }

    const resolveFieldNames = (fieldName) => {
        if (fieldName === 'mobile_no') return ['mobile_no', 'phone'];
        return [fieldName];
    }

    const getPatientDetails = (patient, fieldName) => {
        if (! patient.profile_items) return "";
        const fieldNames = resolveFieldNames(fieldName);
        for (const name of fieldNames) {
            const field = patient.profile_items.find(info => info.field === name)
            if (field && field.value) return field.value;
        }
        return "";
    }

    const formatDate = (date) => {
        var formattedDate = date.toISOString().split('T')[0];
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var amOrPm = hours >= 12 ? 'PM' : 'AM';
        hours = hours % 12 || 12;
        var formattedTime = hours + ':' + (minutes < 10 ? '0' : '') + minutes + ' ' + amOrPm;
        return formatToDdMmYy(formattedDate) + ' ' + formattedTime
    }

    const formatToDdMmYy = (date) => {
        var dat = date.split('-');
        return `${dat[2]}-${dat[1]}-${dat[0]}`;
    }

    return {
        commaFormat,
        currencyToWord,
        decimalFormat,
        onlyCommaFormat,
        capitalize,
        limitText,
        formatNameWithSerial,
        getPatientDetails,
        formatDate,
        formatToDdMmYy
    }
}